<template>
    <div class="step-left" :class="{ show: isShowMenu }">
      <div class="step-btn" @click="showMenu">
        待办清单
        <el-image class="step-img" :src="stepImg"></el-image>
      </div>
      <el-steps direction="vertical" :active="active">
        <el-step
          v-for="(item, index) in stepList"
          :key="index"
          :title="item.name"
          :status="item.state"
          :class="{
            active: active == index,
            skip: item.skip,
            cursor: item.state == 'wait' && item.skip == false,
          }"
          @click.native="change(index, item.action,item.link_type)"
        >
          <div class="step-title" slot="title">
            <div>
              {{ item.name }}
            </div>
            <div class="remark" v-if="item.menu_mark == 'booth'">
              {{ item.remarks }}截止
            </div>
            <!-- <div
              class="unread"
              v-if="item.menu_title == '首页'"
              @click="toMessage"
            >
              未读6
            </div> -->
            <div
              class="unread error"
              v-if="
                item.menu_mark == 'information' &&
                item.state == 'wait' &&
                item.skip
              "
            >
              未完成
            </div>
            <div
              class="unread review"
              v-if="item.menu_mark == 'information' && item.state == 'process'"
            >
              审核中
            </div>
            <div
              class="unread error"
              v-if="item.menu_mark == 'information' && item.state == 'error'"
            >
              未通过
            </div>
            <div class="unread bind" v-if="item.menu_mark == 'attestation'">
              {{ statisData.total }}
              <!-- /{{maxNumber}} -->
            </div>
          </div>
          <span slot="icon">
            <template v-if="item.state == 'finish'">
              <i class="el-icon-check" style="font-weight: bold"></i>
            </template>
            <template v-else-if="item.state == 'process' && active != index">
              <el-image class="process-icon" :src="processIcon"></el-image>
            </template>
            <template v-else-if="item.state == 'wait' && item.skip">
              <el-image class="process-icon" :src="skipIcon"></el-image>
            </template>
            <template v-else>
              {{ index + 1 }}
            </template>
          </span>
        </el-step>
      </el-steps>
<!--      <div class="step-version">V1.0.0</div>-->
    </div>

</template>
  
<script>
import { getConfig,getmyMenu } from "@/api/api";
export default {
  props: ["active"],
  data() {
    return {
      statisData: {
        total: 0,
      },
      maxNumber: "",
      stepImg: require("../assets/menu.png"),
      processIcon: require("../assets/icon_status1.png"),
      skipIcon: require("../assets/icon_status4.png"),
      stepList: [],
      isShowMenu: false
    };
  },
  mounted() {
    this.getMenu();
    // 获取人数上限
    // let maxNumber = JSON.parse(localStorage.getItem("userdata"));
    // this.maxNumber = Number(maxNumber.datainfo.person_num);
  },
  created() {},
  methods: {
    //移动端展示菜单
    showMenu(){
      this.isShowMenu = true;
    },
    getMenu() {
      let data = this.$qs.stringify({type: JSON.parse(localStorage.getItem("userdata")).type});
        getmyMenu(data).then((res) => {
            if (res.code == 1) {
              let { data } = res;
              this.stepList = data;
              this.$store.commit("menuStatus", JSON.stringify(data));
              localStorage.setItem("menu", JSON.stringify(data));
              this.getStepList()
            }
          }).catch((err) => {
            console.log(err);
          });
    },
      //  菜单进度
      getStepList() {
       
            // let { data } = res.data;
            // // 进度状态 0未完成  1已完成  2审核中  3未通过
            // let stepJson = data.step_json;
            // let stepJsonKeys = Object.keys(stepJson);
            // 进度数组
            let arr = this.stepList;
            arr.forEach((item) => {
                  console.log(item.action,"item.action")
                    let status = item.action;
                    switch (status) {
                      case 0:
                        status = "wait";
                        break;
                      case 1:
                        status = "process";
                        break;
                      case 2:
                      status = "finish";
                        break;
                      case 3:
                        status = "process";
                        break;
                      case 4:
                        status = "finish";
                        item.skip = true;
                        break;
                      default:
                        status = "wait";
                        break;
                    }
                    item.state = status;
           
            });
            this.stepList = arr;
          
            this.$emit("getMenuClick", this.stepList);
            this.$store.commit("menuStatus", JSON.stringify(this.stepList));
            this.$forceUpdate();
          
    },
  
    // 跳转到消息列表
    toMessage() {
      this.$router.push({
        path: "/messageList",
      });
    },
    // 步骤条点击事件
    change(index, action,link_type) {
      if (action == 0) {
        return false;
      }
      let { link_url } = this.stepList[index];

      if (link_type == 2) {
          window.open(link_url, "_blank");
        } else {
          this.$router.push({
            path:link_url
          });
        }
    },
  },
};
</script>

<style lang="scss">
.step-left {
  width: 261px;
  min-width: 261px;
  // height: calc(100vh - 60px);
  height: 80vh;
  padding: 115px 24px 50px 31px;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  background: #F5F8FF;
  overflow-y: scroll;
  .step-btn {
    display: none;
  }
  .step-version {
    padding-top: 22px;
    text-align: center;
  }
  .step-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 13px;
    padding-right: 9px;
    min-height: 30px;
    position: relative;
    top: -3px;
    transition: all 0.1s;
    .remark {
      position: absolute;
      bottom: -20px;
      left: 14px;
      color: #999;
      font-size: 12px;
    }
    .unread {
      height: 22px;
      color: #fff;
      padding: 0 5px;
     
      font-size: 14px;
      line-height: 22px;
      text-align: center;
      border-radius: 11px;
      background: #ff4d4f;
      box-sizing: border-box;
    }
    .review {
      min-width: 54px;
      background: #ffb800;
    }
    .bind {
      color: #999;
      background: none;
    }
  }
  .step-title:hover {
    // color: #fff;
    position: relative;
    background: #e1f4ed;
    border-radius: 0 38px 38px 0;
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: -10px;
      width: 10px;
      height: 30px;
    }
  }
  &::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }
  &::-webkit-scrollbar-track-piece {
    background-color: rgba(0, 0, 0, 0.1);
    -webkit-border-radius: 6px;
  }
  &::-webkit-scrollbar-thumb:vertical {
    height: 5px;
    background-color: rgba(125, 125, 125, 0.3);
    -webkit-border-radius: 6px;
  }
  &::-webkit-scrollbar-thumb:horizontal {
    width: 5px;
    background-color: rgba(125, 125, 125, 0.3);
    -webkit-border-radius: 6px;
  }
}
.step-left .el-step.is-vertical {
  cursor: pointer;
  .el-step__main {
    padding-left: 5px;
    .el-step__description {
      padding-left: 15px;
    }
  }
}
.step-left .el-step__head.is-wait {
  color: #fff;
  .el-step__icon {
    background: #c0c4cc;
  }
}
.step-left .el-step__head.is-process {
  color: #fff;
  border-color: #ffb800;
  .el-step__icon {
    background: #ffb800;
    .process-icon {
      width: 24px;
      height: 24px;
      position: relative;
      top: 1px;
      left: 0px;
    }
  }
}
.step-left .el-step__head.is-finish {
  color: #fff;
  border-color: #E40080;
  //border-color: #52C41A;
  .el-step__icon {
    //background: #52C41A;
    background: #E40080;
  }
  .el-step__line {
    background: #E40080;
  }
}
.step-left .el-step__title.is-finish {
  color: #303133;
  font-weight: 700;
}
.step-left .el-step_.el-step__title.is-process_description.is-finish {
  color: #303133;
}
.step-left .el-step__title.is-error {
  color: #303133;
  font-weight: 700;
}
.step-left .el-step__head.is-error {
  .el-step__line {
    border-left: 0 none;
    background: transparent;
  }
  .el-step__icon {
    color: #fff;
    background: #ff4d64;
    .el-icon-close {
      font-weight: bold;
    }
  }
}
.active {
  .step-left .el-step__head.is-wait .el-step__icon {
    background: #E40080;
    border-color: #E40080;
  }
   .el-step__title {
    .step-title {
      color: #fff;
      position: relative;
      border-radius: 0 38px 38px 0;
      background: linear-gradient( 90deg, #E40080 0%, #F27FC0 100%);
    }
     .step-title::before {
      content: "";
      position: absolute;
      top: 0;
      left: -10px;
      width: 10px;
      height: 30px;
      background: url("../assets/nav_bg.jpg") no-repeat;
      background-size: 100% 100%;
    }
  }
  .step-left .el-step__head.is-process {
    color: #fff;
    border-color: #E40080;
    .el-step__icon {
      background: #E40080;
    }
  }
  .step-left .step-title {
    .bind {
      color: #fff;
    }
  }
}

.skip {
  .el-step__head.is-wait .el-step__icon {
    background: #5de6dd;
    border-color: #5de6dd;
    .el-image {
      width: 24px;
      height: 24px;
      top: 1px;
    }
  }
  .step-left .el-step__title.is-wait {
    color: #303133;
    font-weight: 500;
  }
}

.step-left .el-step__head.is-finish .el-step__line {
  display: none;
}
.step-left .el-step__line {
  background: none;
  border-left: 2px dashed #c7c7cc;
  .el-step__line-inner {
    border-width: 0 !important;
  }
}
@media only screen and (max-width: 767px) {
  .el-step.is-vertical{
    left: 12px !important;
  }
  .el-step__title.is-process {
    color: rgba(255, 255, 255, 0.7) !important;
}
  .step-left {
    left: -152px;
    width: 152px;
    color: #fff !important;
    padding: 20px 15px 20px 0;
    min-width: 152px;
    height: calc(100vh - 60px);
    background: #2C2C2E;
    border-radius: 0px 12px 12px 0px;
    transition: all 0.2s;
    .step-btn {
      display: block;
      width: 101px;
      height: 38px;
      font-size: 13px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      position: fixed;
      top: 204px;
      left: 0;
      background: #2c2c2e;
      border-radius: 0px 100px 100px 0px;
      .step-img {
        width: 23px;
        // height: 15px;
      }
    }
  }
  .show{
    left: 0;
    .step-btn{
      display: none;
    }
  }
  .active .el-step__title .step-title,
  .active .el-step__title .step-title::before{
    background: transparent;
  }
  .el-step__title{
    font-size: 14px;
  }
  .skip .el-step__title.is-wait,
  .el-step__title.is-finish{
    color: rgba(255,255,255,0.7);
  }
}
</style>
